// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3b3bd0b2","239":"3d3afbf6","455":"0eaf0c7d"}[chunkId] + ".chunk.js";
};